import { css } from "@emotion/react";
import GBtn from "./GBtn";
import { FC } from "react";

type Props = Omit<React.ComponentProps<typeof GBtn>, "handleClick">;

const GBtnTextRollUp: FC<Props> = (props) => {
  const rollUpStyles = css`
    & {
      overflow: hidden;
      padding-top: 12px;
      padding-bottom: 12px;
    }
    & span {
      color: transparent;
      overflow: hidden;
      position: relative;
      line-height: initial;
    }

    & span:before,
    & span:after {
      content: "${props.text}";
      color: #fff;
      position: absolute;
      width: 100%;
      top: 50%;
      left: 0;
      transition: 0.25s linear;
      line-height: initial;
      opacity: 1;
      transform: translate(0, -50%);
      text-align: center;
    }
    & span:after {
      top: 100%;
      transform: translate(0, 0%);
    }

    &:hover span:before {
      top: 0;
      transform: translate(0, -120%);
    }
    &:hover span:after {
      top: 50%;
      transform: translate(0, -50%);
    }
  `;

  return (
    <GBtn css={rollUpStyles} {...props} hasChild>
      <span>{props.text}</span>
    </GBtn>
  );
};

GBtnTextRollUp.defaultProps = {
  fontColor: "#fff",
  background: "#854DFF",
};

export default GBtnTextRollUp;

// We need to add the below in framer
/*

addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    fontColor: {
        title: "Font Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#854DFF",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 16,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    radius: {
        title: "Radius",
        type: ControlType.Number,
        defaultValue: 8,
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "Home",
    },
    ripple: {
        title: "Ripple",
        type: ControlType.Boolean,
        description: "Adds a ripple effect on click if true",
        defaultValue: true,
    })
*/
